import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { useInputAttributes } from '@/hooks/useInputAttributes';
import { themeSelector } from '@/state/config';
import styles from './Input.module.scss';
export const Input = ({ label, required, register, error, isDirty, defaultValue, name = '', }) => {
    const theme = useRecoilValue(themeSelector);
    const { extraAttributes } = useInputAttributes();
    return (_jsxs("div", { className: cn(styles.container, styles[theme]), children: [_jsxs("div", { className: cn(styles.inputContainer, {
                    [styles.required]: required,
                    [styles.error]: error,
                }), children: [_jsx("input", Object.assign({ name: name, className: cn(styles.input, {
                            [styles.dirty]: isDirty,
                        }), type: "text" }, register, { defaultValue: defaultValue }, extraAttributes)), _jsx("span", { className: styles.label, children: label })] }), error && _jsx("p", { className: styles.errorMessage, children: error })] }));
};
